import { TEspSponsorshipStatus } from '../model/types'

interface IEspPartnerVisibility {
  status: TEspSponsorshipStatus
  /** The partner heads its group (`HierarchyType = Headquarters`). */
  isHeadquarters: boolean
  /** A PBM has signed a plan of the current fiscal year. */
  isPlanSigned: boolean
}

/** ESP shows for a partner already in the program (a sponsor or a nomination waiting), and for a
 *  top partner with a joint business plan in place (a PBM has signed it), who may
 *  be nominated. */
export const isEspPartnerVisible = ({
  status,
  isHeadquarters,
  isPlanSigned,
}: IEspPartnerVisibility) => status !== 'notOnboarded' || (isHeadquarters && isPlanSigned)
